/**
 * @Author: Michael Neumair <mBook>
 * @Date:   2016-09-26T10:50:29+02:00
 * @Email:  7q7w7e7r@gmail.com
 * @Last modified by:   mBook
 * @Last modified time: 2016-10-05T11:55:26+02:00
 */


import React, {Component} from 'react';
import {connect} from 'react-redux';
import {actions, getField} from 'react-redux-form/src';
import PropTypes from 'prop-types';
import MPositionFormChildrenCheckout from
  'checkout/components/MPositionFormChildrenCheckout';
import MFieldsetCheckout from 'common/forms/components/MFieldsetCheckout';
import MHintboxCheckout from 'checkout/components/MHintboxCheckout';
import ALinkColor from 'common/links/components/ALinkColor';
import MFieldsetGroup from 'common/forms/components/MFieldsetGroup';
import {requireString, requireNumber} from
  'common/inputs/containers/validators';
import MInputGroupRadioText from
  'common/inputs/components/MInputGroupRadioText';
import AInputRadioText from 'common/inputs/components/AInputRadioText';
import OInputFieldGroup from 'common/inputs/containers/OInputFieldGroup';
import OInputFieldCalculatorCheckout from
  'common/inputs/containers/OInputFieldCalculatorCheckout';
import targetValues from 'checkout/constants/targetValues';
import {i18nInterface} from 'utilities/i18n_common';
import queryString from 'query-string';

import getConstants from '../../config/constants.common';
const {DEPOSIT_MAX, DEPOSIT_MIN} = getConstants();

/**
 * called from react-redux connect() on a redux store update
 *
 * @param {object} state
 * @param {object} ownProps
 * @return {object}
 */
function mapStateToProps(state, ownProps) {
  const {
    formModel,
    supportOverMaxDeposit,
  } = ownProps;

  // Check if we have valid vm_id and uvm_id parameters in the URL
  const urlParams = queryString.parse(window.location.search);
  const hasValidVmAndUvm = urlParams.vm_id && urlParams.uvm_id && 
    state.checkout.billing.partner_code && 
    state.checkout.uce.subPartnerCode;

  if (!supportOverMaxDeposit) {
    return {
      hasValidVmAndUvm
    };
  }

  // TODO signal certain errors through store not regexp matching
  const depositError = getField(state, `${formModel}.objective.deposit`).errors;
  const overRegexp = /Maximalhöhe|Maximum/; // i18n
  const findNumber = /[0-9]{3,32}/;

  return {
    hasValidVmAndUvm,
    overMaxDeposit: typeof(depositError) === 'string' &&
      overRegexp.exec(depositError),
    maxDeposit: typeof(depositError) === 'string' &&
      parseInt(findNumber.exec(depositError)[0]) ||
      0,
  };
}

/**
 * called from react-redux connect() on a redux store update
 * enables component to send actions via dispatch() to react-redux
 *
 * @param {function} dispatch
 * @param {object} ownProps
 * @return {object}
 */
function mapDispatchToProps(dispatch, ownProps) {
  const {
    formModel,
    activeMaskMerge,
  } = ownProps;
  return {
    applyFormFilterKeys: () => {
      dispatch({
        type: 'HAS_ACTIVE_MASK_FOR',
        activeMask: [
          `${formModel}.objective.target`,
          `${formModel}.objective.deposit`,
          `${formModel}.objective.paymentConditions`,
        ],
        activeMaskMerge,
      });
    },
    setPrefillTarget: (val) => dispatch(
        actions.change(`${formModel}.objective.target`, val),
    ),
  };
}

/**
 * OFormCheckoutStart - …
 **/
class OFormCheckoutStart extends Component {
  /**
   * TODO jsdoc
   *
   * @return {undefined}
   */
  componentDidMount() {
    const {
      applyFormFilterKeys,
      prefillTarget,
      setPrefillTarget,
    } = this.props;

    applyFormFilterKeys();

    if (prefillTarget == 'newContract' ||
      prefillTarget == 'retrieveDeposit') {
      setPrefillTarget(prefillTarget);
    }
  }

  /**
   * TODO jsdoc
   *
   * @return {object}
   */
  render() {
    const {
      formModel,
      helpLabel,
      helpIcon,
      onPressHelp,
      showErrors,
      prefillTarget,
      overMaxDeposit,
      maxDeposit,
      hasValidVmAndUvm,
    } = this.props;

    /* eslint-disable max-len */
    const calculatorEl = (
      <MFieldsetCheckout
        legend={i18nInterface('headlines.fieldset.sum')}
        {...this.getHelpToolProperties('objective.deposit')}

      >
        <MFieldsetGroup>
          <OInputFieldCalculatorCheckout
            model={`${formModel}.objective.deposit`}
            modelPaymentConditions={`${formModel}.objective.paymentConditions`}
            label={i18nInterface('label.objective.sum')}
            description={i18nInterface('label.objective.sum_description')}
            placeholder={i18nInterface('label.objective.placeholder')}
            sumName={i18nInterface('label.objective.sumName')}
            sumInfo={i18nInterface('label.objective.sumInfo')}
            validators={{
              required: requireNumber,
              isTooHigh: (value) => {
                return value <= DEPOSIT_MAX;
              },
              isTooLow: (value) => {
                return value >= DEPOSIT_MIN;
              },
            }}
            validateOn={'blur'}
            messages={{
              required: i18nInterface('error.missing.sum'),
              isTooHigh: i18nInterface('error.custom.sum.tooHigh'),
              isTooLow: i18nInterface('error.custom.sum.tooLow'),
            }}
            showErrors={showErrors}
          />
        </MFieldsetGroup>
        {overMaxDeposit && maxDeposit && <MHintboxCheckout
          title={i18nInterface('otherProduct.reasonDepositTitle')}
          hint={
            i18nInterface('otherProduct.reasonDepositText')
                .replace(/%maxDeposit/g, maxDeposit.toString())
          }
          actions={
            <ALinkColor
              href={i18nInterface('otherProduct.linkDepositHref')}
            >
              {i18nInterface('otherProduct.linkDepositText')}
            </ALinkColor>
          }
        />}
      </MFieldsetCheckout>
    );

    let targetEl = null;
    if (!(prefillTarget == 'newContract') &&
      !(prefillTarget == 'retrieveDeposit') &&
      !hasValidVmAndUvm) {
      targetEl = (
        <MFieldsetCheckout
          legend={i18nInterface('headlines.fieldset.target_of_contract')}
          {...this.getHelpToolProperties('objective.target')}
        >
          <OInputFieldGroup
            model={`${formModel}.objective.target`}
            component={MInputGroupRadioText}
            label={i18nInterface('label.objective.target')}
            validators={{required: requireString}}
            messages={{required: i18nInterface('error.missing.objective.target')}}
            showErrors={showErrors}
          >
            <AInputRadioText
              htmlValue={targetValues.newContract}
            >
              {i18nInterface('label.objective.targetValues.new1')}
              <strong>{i18nInterface('label.objective.targetValues.newVerb')}</strong>
              {i18nInterface('label.objective.targetValues.new2')}
            </AInputRadioText>
            <AInputRadioText
              htmlValue={targetValues.retrieveDeposit}
            >
              {i18nInterface('label.objective.targetValues.old1')}
              <strong>{i18nInterface('label.objective.targetValues.oldVerb')}</strong>
              {i18nInterface('label.objective.targetValues.old2')}
            </AInputRadioText>
          </OInputFieldGroup>
        </MFieldsetCheckout>
      );
    }
    /* eslint-enabale max-len */

    return <div className="o-form o-form-checkout-start">
      <MPositionFormChildrenCheckout>
        {calculatorEl}
        {targetEl}
      </MPositionFormChildrenCheckout>
    </div>;
  }

  /**
   *
   * @param {string} helpId
   * @return {null|{onPressTool: (function(*=): *), toolIcon, toolLabel}}
   */
  getHelpToolProperties(helpId) {
    const {
      helpLabel,
      helpIcon,
    } = this.props;

    const help = i18nInterface(helpId);
    if (typeof help == 'string' && help === '') {
      return null;
    }

    return {
      toolLabel: helpLabel,
      toolIcon: helpIcon,
      onPressTool: (e) => this.props.onPressHelp(helpId, e),
    };
  }
}

OFormCheckoutStart.propTypes = {
  /**
   * model of the form
   */
  formModel: PropTypes.string.isRequired,
  /**
   * label of help button
   */
  helpLabel: PropTypes.string.isRequired,
  /**
   * icon of help button
   */
  helpIcon: PropTypes.string.isRequired,
  /**
   * show errors for input fields on ...
   * see: https://davidkpiano.github.io/react-redux-form/docs/api/Errors.html#show
   */
  showErrors: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool,
  ]).isRequired,
  /**
   * request help for a model
   * passes the model for which help is requested
   */
  onPressHelp: PropTypes.func,
  /**
   * prefill target with given value
   */
  prefillTarget: PropTypes.string,
  /**
   * enable a hintbox to be displayed if max deposit rules match
   * the rules are tested on '$formModel.objetive.deposit' field
   */
  supportOverMaxDeposit: PropTypes.bool,

  /**
   * props originating in mapStateToProps function:
   * * overMaxDeposit
   * * maxDepsoit
   */
  overMaxDeposit: PropTypes.bool,
  maxDeposit: PropTypes.number,
  /**
   * extends an already mounted mask (OFormCheckout* container components)
   * see custom reducer and applyFormFilterKeys() method
   */
  activeMaskMerge: PropTypes.bool,
  hasValidVmAndUvm: PropTypes.bool,
};
OFormCheckoutStart.defaultProps = {
  helpLabel: i18nInterface('label.help'),
  helpIcon: i18nInterface('label.helpIcon'),
  showErrors: true,
  supportOverMaxDeposit: false,
  overMaxDeposit: false,
  maxDeposit: 0,
  activeMaskMerge: false,
  hasValidVmAndUvm: false,
};
export default connect(mapStateToProps, mapDispatchToProps)(OFormCheckoutStart);

